import moment from "moment";
import React from "react";
import { useTranslation } from "react-i18next";
import submit from "submit-form";
import { DATE_FORMATS } from "../../../../constants";

const TeamTabs = ({ currentTab }) => {
  const { t } = useTranslation("coaching-portal");
  const tabs = [
    { value: "manager", label: t("teams.tabs.teamProgramManager") },
    { value: "overview", label: t("teams.tabs.overview") },
    { value: "members", label: t("teams.tabs.members") },
    { value: "information", label: t("teams.tabs.teamInformation") },
  ];
  return (
    <nav role="tablist">
      {tabs.map((tab) => (
        <a
          aria-current={currentTab === tab.value ? true : undefined}
          onClick={() => {
            const url = `/actions/refresh`;

            submit(url, {
              method: "GET",
              body: {
                currentTab: tab.value,
                ...(tab.value === "overview"
                  ? { month: moment().format(DATE_FORMATS.DATE_YEAR_FORMAT) }
                  : {}),
              },
            });
          }}
          key={`team-tab-${tab.value}`}
        >
          {tab.label}
        </a>
      ))}
    </nav>
  );
};

export default TeamTabs;
